export const SECTION_NAME = 'Live Agent Configurator';

export const EXCEPT_DAY_CONTROL = 'except-day-control';
export const EXCEPT_DAY_EMPTY_ERROR = 'except-day-empty-error';
export const EXCEPT_DAY_EMPTY_MESSAGE = 'Except day cannot be empty';
export const EXCEPT_DAY_DUPLICATE_ERROR = 'EXCEPT_DAY_DUPLICATE_ERROR';
export const EXCEPT_DAY_DUPLICATE_MESSAGE = 'Each day must be unique.';

export const AVAILABLE_ON_CONTROL = 'available-on-control';
export const AVAILABLE_ON_TO_BEFORE_START_ERROR = 'available-on-to-before-start-error';
export const AVAILABLE_ON_TO_BEFORE_START_MESSAGE = 'End time cannot be before the start time';
